import { createGlobalStyle } from 'styled-components'

import { DISABLED_ROW_WITH_OPACITY_CLASSNAME } from 'src/consts/table'
import {
  blue600,
  gray100,
  gray1000,
  gray200,
  gray400,
  gray500,
  navy900,
} from 'src/styles/color-theme'

import { GetCalendarPropsGlobalStyles } from './components/CalendarBase'
import { GetDatePickerBasePropsGlobalStyles } from './components/DatePickerBase'

export const GlobalStyles = createGlobalStyle`
  ${GetCalendarPropsGlobalStyles}
  ${GetDatePickerBasePropsGlobalStyles}
  .ant-table {
    .ant-table-row.${DISABLED_ROW_WITH_OPACITY_CLASSNAME} {
      opacity: 0.5;
    }
  }
  .mapboxgl-ctrl-top-left {
    max-width: 35%;
    .mapboxgl-ctrl-geocoder {
      width: calc(100% - 10px);
      min-width: 1px;
      margin-right: 0;
    }
  }
  .mapboxgl-ctrl-top-right {
    max-width: calc(65% - 9px);
    margin-left: 10px;
  }
  .wh-vertical-scroller-container {
    display: flex;
    flex-direction: column;
    height: 100%;

    &> .wh-vertical-scroller-container-scroll {
      flex: 1;
      min-height: 0;
    }
  }

  .wh-spin-100 {
    .ant-spin-nested-loading {
      height: 100%;

      .ant-spin-container {
        height: 100%;
      }
    }
  }

  .wh-select-hide-selected-option {
    &&& {
      /* Both renderings: the seam re-emits none of antd's own class names and
         keys its parts by data-slot instead (AGENTS.md, the popup seams). */
      .ant-select-item-option-selected,
      [data-slot='select-item'][data-selected-option] {
        display: none;
      }
    }
  }


  .wh-antd-form {
    &.disabled {
       /* Both renderings — see src/antd/DatePicker/DatePicker.shadcn.tsx. The
          seam re-emits none of antd's picker class names and keys its parts by
          data-slot, so each picker rule below carries a twin. */
       .ant-picker-input > input[disabled],
       [data-slot='picker-input'] > input[disabled] {
          color: ${navy900};
        }
        
        /* Both renderings — see src/antd/Checkbox.shadcn.tsx. The seam keys
           its parts by data-slot and carries the disabled state on the
           wrapper, so each rule below that reached into antd's class names
           carries a twin. */
        .ant-checkbox-disabled + span,
        [data-slot='checkbox'][disabled] + [data-slot='checkbox-label'] {
          color: ${gray1000};
        }

        .projectIdCol {
          display: none;
        }
        
        .selectAllDaysCheckboxCol {
          display: none;
        }
        
        .ant-checkbox-group,
        [data-slot='checkbox-group'] {
          margin-left: 0 !important;
          cursor: default !important;
        }
        
        .ant-checkbox-wrapper.ant-checkbox-wrapper-disabled,
        [data-slot='checkbox-wrapper'][data-disabled] {
          cursor: default !important;
        }
        
        .ant-checkbox-disabled,
        [data-slot='checkbox'][disabled] {
          cursor: default !important;
        } 
        
        .ant-checkbox-disabled + span,
        [data-slot='checkbox'][disabled] + [data-slot='checkbox-label'] {
          cursor: default !important;
        }
        
        .ant-radio-button-wrapper-disabled,
        [data-slot='radio-button-wrapper'][data-disabled] {
          cursor: default !important;
        }
        
        .ant-select-disabled.ant-select-multiple .ant-select-selection-item,
        [data-slot='select'][data-disabled][data-mode='multiple']
          [data-slot='select-selection-item'] {
          cursor: default !important;
        }
        
        .ant-picker-range,
        [data-slot='picker'][data-range] {
          border-color: ${gray200} !important;
          background: ${gray200} !important;
          color: ${navy900};
          cursor: default !important;
        }
        
        .ant-picker-input > input[disabled],
        [data-slot='picker-input'] > input[disabled] {
          cursor: default !important;
        }

        /* antd paints the indeterminate dash as a pseudo-element and this
           hands it the inherited colour back. The seam draws a real glyph
           that already inherits (src/antd/Checkbox.shadcn.tsx), so this rule
           has no shadcn twin — there is nothing to undo. */
        .ant-checkbox-indeterminate .ant-checkbox-inner::after {
          background-color: inherit;
        }
        
        .ant-picker-disabled .ant-picker-range-separator .ant-picker-separator,
        [data-slot='picker'][data-disabled] [data-slot='picker-range-separator'] {
          cursor: default !important;
        }
        
        .ant-radio-button-wrapper-disabled, .ant-radio-button-wrapper-disabled::before,
        [data-slot='radio-button-wrapper'][data-disabled] {
          display: none;
        }
        
        .button-col-24 {
          display: none;
        }

        .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {
          border-color: ${blue600} !important;
        }

        /* The seam's box IS the control, and its tick is that box's own
           colour, so the two antd rules above collapse into one twin. */
        [data-slot='checkbox'][disabled][data-state='checked'] {
          color: ${blue600} !important;
        }

        .ant-checkbox-disabled .ant-checkbox-inner {
          border-color: ${gray100} !important;
          background: ${gray100};
        }

        [data-slot='checkbox'][disabled] {
          border-color: ${gray100} !important;
          background: ${gray100} !important;
        }

        .ant-picker-disabled,
        [data-slot='picker'][data-disabled] {
          border-color: ${gray200} !important;
          background: ${gray200} !important;
          color: ${navy900};
        }

        .ant-select-disabled.ant-select:not(.ant-select-customize-input)
          .ant-select-selector,
        [data-slot='select'][data-disabled] [data-slot='select-selector'] {
          background: ${gray200};
          border-color: ${gray200};
          color: ${navy900};
        }

        .ant-select-disabled.ant-select-multiple .ant-select-selection-item,
        [data-slot='select'][data-disabled][data-mode='multiple']
          [data-slot='select-selection-item'] {
          background: ${gray200};
          border: 1px solid ${gray500};
          color: ${navy900};
          border-radius: 2px;
        }

        .ant-radio-button-wrapper-disabled.ant-radio-button-wrapper-checked,
        [data-slot='radio-button-wrapper'][data-disabled][data-state='checked'] {
          background: ${gray200};
          /* Daybreak Blue / blue-6 */

          border: 1px solid ${gray200};
          box-sizing: border-box;
          border-radius: 2px;
          display: inherit;

          color: ${navy900};
        }
        
        /* Both renderings — see src/antd/Input.shadcn.tsx. */
        .ant-input-group-addon, [data-slot='input-addon'] {
          border: 0px;
          background: ${gray400};
        }
        
        .ant-select-selection-placeholder,
        [data-slot='select-selection-placeholder'] {
          font-size: 0
        }
        
        .ant-input-group.ant-input-group-compact > *:first-child, .ant-input-group.ant-input-group-compact > .ant-select:first-child > .ant-select-selector, .ant-input-group.ant-input-group-compact > .ant-select-auto-complete:first-child .ant-input, .ant-input-group.ant-input-group-compact > .ant-cascader-picker:first-child .ant-input {
          display: none
        }
        
        .ant-input-group.ant-input-group-compact > *:last-child, .ant-input-group.ant-input-group-compact > .ant-select:last-child > .ant-select-selector, .ant-input-group.ant-input-group-compact > .ant-cascader-picker:last-child .ant-input, .ant-input-group.ant-input-group-compact > .ant-cascader-picker-focused:last-child .ant-input {
          width: 100% !important;
        }
        .mapboxgl-ctrl-top-right .mapboxgl-ctrl-geocoder.mapboxgl-ctrl input {
          display: none;
        }
        
        .mapboxgl-ctrl-geocoder--icon-search {
          display: none
        }
        
        .mapboxgl-marker {
          pointer-events: none
        }
        
        .ant-select-single .ant-select-selector .ant-select-selection-item,
        [data-slot='select']:not([data-mode])
          [data-slot='select-selection-item'] {
          user-select: text;
        }
        
        .ant-picker ant-picker-range ant-picker-disabled {
        
        }
        
        .ant-picker-input ant-picker-input-active {
          cursor: default !important;
        }
        
        .ant-picker-disabled .ant-picker-range-separator .ant-picker-separator,
        [data-slot='picker'][data-disabled] [data-slot='picker-range-separator'] {
          cursor: default !important;
        }
        
        .ant-radio-button-wrapper-disabled,
        [data-slot='radio-button-wrapper'][data-disabled] {
          cursor: default !important;
        }
        
        .ant-checkbox-disabled,
        [data-slot='checkbox'][disabled] {
          cursor: default !important;
        }
        
        /* Both renderings — see src/antd/Switch.shadcn.tsx. The seam merges
           loading into the control's own disabled attribute, so one twin
           covers both of antd's classes. */
        .ant-switch-loading, .ant-switch-disabled,
        [data-slot='switch'][disabled] {
          cursor: default !important;
        }
        
        .ant-switch-loading *, .ant-switch-disabled *,
        [data-slot='switch'][disabled] * {
          cursor: default !important;  
        }
        
        .ant-picker-input > input[disabled],
        [data-slot='picker-input'] > input[disabled] {
          cursor: default !important;    
        }
        
        
        /* SELECTS — the antd rendering, then the shadcn one beside it. */
        .ant-select,
        [data-slot='select'] {
          border-color: ${gray200} !important;
          background: ${gray200} !important;
          color: ${navy900};
          cursor: default !important;
        }
        
        .ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector,
        [data-slot='select'][data-disabled] [data-slot='select-selector'] {
          cursor: default;
        }
        
        .ant-input {
          cursor: default !important;
        }

        .ant-select .ant-select-arrow,
        [data-slot='select'] [data-slot='select-arrow'] {
          color: transparent;
        }
        
        .ant-select-selector,
        [data-slot='select-selector'] {
          border-color: ${gray200} !important;
          background: ${gray200} !important;
          color: ${navy900};
        }
        
        /* INPUTS — the antd rendering. The ant-input-number rules below are a
           DIFFERENT antd component (src/antd/InputNumber), ported since; its
           data-slot twins follow them. */
        .ant-input, .ant-input-affix-wrapper {
          cursor: default !important;
          border-color: ${gray200} !important;
          background: ${gray200} !important;
          color: ${navy900};
        }

        /* INPUTS — the shadcn rendering (src/antd/Input.shadcn.tsx), which
           keys its parts by data-slot. Same read-only styling, EXCEPT on the
           login form: a login is not read-only, and inputs that paint
           themselves flat grey defeat the whole point of the nicer page, so
           the shadcn login form opts out by carrying wh-login-form
           (src/pages/login/login-form/ui/LoginForm.shadcn.tsx). The antd
           login form takes the same fix a different way — it passes
           createMode to FormFn (LoginForm.antd.tsx), so .disabled is
           never applied there in the first place and this rule never
           matches it. Other FormFn call sites that omit createMode
           (register, company/create) still default to view mode; fix them
           the same way if they turn out to need it. */
        &:not(.wh-login-form) {
          [data-slot='input'], [data-slot='input-affix-wrapper'],
          [data-slot='textarea'] {
            cursor: default !important;
            border-color: ${gray200} !important;
            background: ${gray200} !important;
            color: ${navy900};
          }
        }
      
      .ant-input-number-input {
        cursor: default !important;
        border-color: ${gray200} !important;
        background: ${gray200} !important;
        color: ${navy900};
      }
      .ant-input-number-group {
        cursor: default !important;
        border-color: ${gray200} !important;
        background: ${gray200} !important;
        color: ${navy900};
      }
      .ant-input-number {
        cursor: default !important;
        border-color: ${gray200} !important;
        background: ${gray200} !important;
        color: ${navy900};
      }
      .ant-input-number-group-addon{
        cursor: default !important;
        border-color: ${gray200} !important;
        background: ${gray200} !important;
        color: ${navy900};
      }

      /* NUMBER FIELDS — the shadcn rendering (src/antd/InputNumber), which
         takes its chrome from src/antd/Input.shadcn.tsx. The field box and
         the inner input are already covered by the [data-slot='input'] /
         [data-slot='input-affix-wrapper'] rules above; what is left is the
         addon group and the steppers, which have no antd class in common
         with them. */
      [data-slot='input-group'],
      [data-slot='input-addon'],
      [data-slot='input-number-handlers'] {
        cursor: default !important;
        border-color: ${gray200} !important;
        background: ${gray200} !important;
        color: ${navy900};
      }
      
        /* PHONE INPUT */
        .react-tel-input {
          input {
            cursor: default !important;
            border-color: ${gray200} !important;
            background: ${gray200} !important;
            color: ${navy900};
          }
          .flag-dropdown {
            cursor: default !important;
            border-color: ${gray200} !important;
            background: ${gray200} !important;
            color: ${navy900};
          }
        }
    }
    
    .wh-styled-simple-dropdown {
      /* The shadcn seam binds its trigger with Radix asChild, so the marker
         lands on the SAME element antd puts .ant-dropdown-trigger on — hence
         one extra selector rather than a rewritten rule. */
      .ant-dropdown-trigger > .anticon.anticon-down,
      .ant-dropdown-link > .anticon.anticon-down,
      .ant-dropdown-button > .anticon.anticon-down,
      [data-slot='dropdown-menu-trigger'] > .anticon.anticon-down {
        font-size: 14px;
        line-height: 0;
        margin-left: 4px;
      }
      .ant-btn-link {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

`
